import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from "rxjs/operators";
import { environment } from "src/environments/environment";
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { nanoid } from "nanoid";
import Swal from 'sweetalert2'

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

const CSV_TYPE = 'text/csv;charset=utf-8';
const CSV_EXTENSION = '.csv';


const apiLink = environment.apiUrl;
const apiUrlZip = environment.apiUrlZip;
const apiLinkRuc = environment.apiUrlSenaceRuc;
const apiLinkDni = environment.apiUrlSenaceDNI;

const folderExterno = environment.folderProyecto;

@Injectable({
  providedIn: 'root'
})
export class SenaceService {

  constructor(
    private http: HttpClient
  ) {

  }


  getQuery<T>(query: string) {
    const url = `${apiLink}${query}`;
    return this.http.get<T>(url)
    // .pipe(
    //   delay(2000)
    // )
  }
  postQuery<T>(body, file) {
    const header = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Accept': 'application/json'
    })
    const url = `${apiLink}${file}`;
    return this.http.post<T>(url, body, { headers: header });
  }
  getTipoEstudio() {
    return this.getQuery<any>('GetTipoProyecto');
  }
  getUbigeo(tipo: string, codigo?: string) {
    switch (tipo) {
      case 'departamento':
        return this.getQuery<any>('GetDepartamentos');
        break;
      case 'provincia':
        return this.getQuery<any>(`GetProvincias/${codigo}`);
        break;
      case 'distrito':
        return this.getQuery<any>(`GetDistritos/${codigo}`);
        break;
    }
  }
  getActividad() {
    return this.getQuery<any>('GetActividades');
  }
  getEstado() {
    return this.getQuery<any>('GetEstado');
  }
  // Para obtner el nro de expediente segun el UID generado
  getExpedientePorUID(uid?: string) {
    return this.getQuery<any>(`GetUrlId?urlId=${uid}`);
  }
  postBuscarConsulta(data: any) {
    const params = new HttpParams()
      .set("TITULAR", data.titular)
      .set("RUC_TITULAR", data.ruc)
      .set("EXPEDIENTE", data.nroexpediente)
      .set("TIPO_PROYECTO", data.tipoestudio)
      .set("NOMBRE_PROYECTO", data.tituloproyecto)
      .set("NOMBRE_UNIDAD", data.unidadproyecto)
      .set("Departamento", data.departamento)
      .set("Provincia", data.provincia)
      .set("Distrito", data.distrito)
      .set("ID_ACTIVIDAD", data.actividad)
      .set("ID_ESTADO_EXP", data.estado)
      .set("FInicio", data.fechaDesde)
      .set("FFin", data.fechaHasta)
      .set("EnAporte", data.enAporte);

    return this.postQuery(params.toString(), `GetVista/parametros`)
      .pipe(
        // delay(2000),
        map(
          (resp: any[]) => {
            return resp['Result'].map(
              resultado => {         
                
                /*this.registrarAnexoUId(resultado.EXPEDIENTE, resultado.IDEXPEDIENTE).subscribe(
                  (resp) => {                 
                    console.log(resp.Result.url);
                    
                  }, (error) => {
                    Swal.fire({
                      title: `Aviso`,
                      text: 'Error al obtener la UID de la url del expediente',
                      icon: 'error'
                    })
                  }
                );*/
                
                return {
                  tituloProyecto: resultado.NOMBRE_PROYECTO,
                  titularNombre: resultado.TITULAR,
                  unidadProyecto: resultado.NOMBRE_UNIDAD,
                  tipoEstudio: resultado.EXPEDIENTE.split('-')[1],
                  actividad: resultado.NOMBRE_ACTIVIDAD,
                  ubicacion: resultado.UBIGEOS,
                  expediente: resultado.EXPEDIENTE,
                  fechaExpediente: resultado.FECHA_EXPEDIENTE,
                  estado: resultado.NOMBRE_ESTADO_EXP,
                  idExpediente: resultado.IDEXPEDIENTE,
                  idProyecto: resultado.ID_PROYECTO,
                  enAporte: resultado.ENAPORTE,
                  url: resultado.URL,
                  fechainivigencia: resultado.FECHAINIVIGENCIA,
                  fechafinvigencia: resultado.FECHAFINVIGENCIA                  
                }
              }
            )
          }
        )
      )
  }

  private _url(): string {
    const protocol = window.location.protocol;
    const domain = window.location.hostname;
    const port = window.location.port;
    let url = "";

    if(port){
      url = `${protocol}://${domain}:${port}`;
    }else{
      url = `${protocol}://${domain}`;
    }
    url = url.replace("::",":");
    return url;
  }

  getUrlUId(uid:string):string{
    let url = this._url();
    url = `${url}/${folderExterno}#/g/${uid}`;
    return url;
  }

  registrarAnexoUId(expediente: any, idExpediente: any) {
    const uid = nanoid();
    let url = this._url();
    url = `${url}/${folderExterno}#/g/${uid}`; // http://localhost:4200/#/g/V2e4oKVfXK9dbIWzeE78a
    const params = new HttpParams()
      .set("ruta", url)
      .set("idExpediente", idExpediente)
      .set("expediente", expediente)
      .set("urlId", uid)
      ;
    return this.postQuery<any>({}, `InsertUrl?${params.toString()}`)
  }

  getDetalleExpediente(codigoExpte: string) {
    localStorage.removeItem('detalle');
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': 'Basic ' + btoa('ventanilla:1'),
        'Accept': 'application/json',
      })
    };
    var version = '';
    const params = new HttpParams()
    .set('codigoExpte', codigoExpte)
    .set('version', version);
    return this.http.post<any>('https://eva.senace.gob.pe:8443/plan/senace/webresources/microservices/execution/WS_EXT_INFOEXPTE',
      params.toString()
      , httpOptions);
  }
  getDocumentosEmitidos(expediente: string) {
    return this.getQuery<any>(`GetDocumentosEmitidos/${expediente}`);
  }

  getGeneraToken(idSolicitud: number) {
    return this.getQuery<any>(`GetGeneraToken/${idSolicitud}`);
  }

  getConsultarDni(documento: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Accept': 'application/json',
      })
    };
    return this.http.get(`${apiLinkDni}${documento}`, httpOptions)
      .pipe(
        map(
          (resp: any) => {
            if (resp.listPersonas) {
              const datos = resp.listPersonas[0];
              return {
                nombres: datos.Nombre,
                apellidos: `${datos.Paterno} ${datos.Materno}`,
                info: ''
              }
            } else {
              return {
                nombres: '',
                apellidos: '',
                info: resp.Info
              }
            }

          }
        )

      )
  }
  getConsultarRuc(documento: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Accept': 'application/json',
      })
    };
    return this.http.get(`${apiLinkRuc}${documento}`, httpOptions)
      .pipe(
        map(
          (resp: any) => {
            return { razonSocial: resp.ddp_nombre }
          }
        )
      )
  }
  getDocumentoAlfresco(uid: string) {
    return `https://eva.senace.gob.pe:8443/AppIntegracionCMIS/rest/WebServiceECM/DownloadByGet?docId=${uid}`
  }
  subirDocumento(formData, params?: any) {
    const header = new HttpHeaders({
      'Accept': 'application/json',
    })
    return this.http.post(`${apiLink}CargaDoc?idAc=${params.idAc}&idAcOb=${params.idAcOb}&idExp=${params.idExp}&sustento=${params.sustento}&expediente=${params.expediente}`, formData, { headers: header });
  }

  enviarFormulario(formData) {   

    const httpOptions = new HttpHeaders({        
      'Authorization': 'Basic ' + btoa('ventanilla:1'),
      'Accept': '*/*'
    })              

    return this.http.post<any>('https://eva.senace.gob.pe:8443/plan/senace/webresources/file/upload', formData, {
      headers: httpOptions,
      responseType: 'blob' as 'json'
    });   

    /*const params = new HttpParams()
      .set("correo", data.correo)
      .set("tipoPersona", data.tipoPersona)
      .set("nroDocumento", data.nroDocumento)
      .set("nombreCompleto", data.nombreCompleto)
      .set("sexo", data.sexo)
      .set("sustento", data.sustento)
      .set("observacion", data.observacion)
      .set("Expediente", data.Expediente)
      .set("expedienteId", data.expedienteId)
    return this.postQuery<any>(params.toString(), 'InsertAporte')*/
  
  }
  descargarEnZip(data) {
    let params = new HttpParams()
    params = params.append("nombre", data.nombre);
    data.path.forEach(element => {
      params = params.append("path", element)
    });
    return this.http.get(`${apiUrlZip}DescargaZip?${params.toString()}`, {
      responseType: 'arraybuffer'
    });

  }
  // Exportar Excel
  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_exported' + EXCEL_EXTENSION);
  }
  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const myworksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const myworkbook: XLSX.WorkBook = { Sheets: { 'data': myworksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(myworkbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }
  private saveAsFile(buffer: any, fileName: string, fileType: string): void {
    const data: Blob = new Blob([buffer], { type: fileType });
    FileSaver.saveAs(data, fileName);
  }

  // Exportar a CSV
  public exportToCsv(rows: object[], fileName: string, columns?: string[]): string {
    if (!rows || !rows.length) {
      return;
    }
    const separator = ',';
    const keys = Object.keys(rows[0]).filter(k => {
      // if (columns?.length) {
      if (columns) {
        return columns.includes(k);
      } else {
        return true;
      }
    });
    const csvContent =
      keys.join(separator) +
      '\n' +
      rows.map(row => {
        return keys.map(k => {
          let cell = row[k] === null || row[k] === undefined ? '' : row[k];
          cell = cell instanceof Date
            ? cell.toLocaleString()
            : cell.toString().replace(/"/g, '""');
          if (cell.search(/("|,|\n)/g) >= 0) {
            cell = `"${cell}"`;
          }
          // return cell;
          return `${cell} `;
        }).join(separator);
      }).join('\n');
    this.saveAsFile(csvContent, `${fileName}${CSV_EXTENSION}`, CSV_TYPE);
  }

  /*=========================================================
  =            DATOS  A MOSTRAR EN LAS SECCIONES            =
  =========================================================*/
  private getNodo(data: any, nodo: string, nodo2?: string, nodo3?: string) {
    let resultado: any;

    if (data.solicitud) {
      for (const keySolicitud in data.solicitud) {
        if (keySolicitud === 'secciones') {
          for (const keySeccion in data.solicitud.secciones) {
            let secciones = data.solicitud.secciones[keySeccion];
            for (const keyCapitulos in secciones) {
              if (keyCapitulos === 'capitulos') {
                let capitulos = secciones['capitulos'];
                for (const keyDatos in capitulos) {
                  let datos = capitulos[keyDatos];

                  if (datos['nombre'].includes('Descripción del proyecto') && nodo === 'datosGeneralesCertificacion') {
                    resultado = datos['datos'];
                  }

                  // Etapas del proyecto...
                  if (datos['nombre'].includes('Características del Proyecto') && nodo === 'etapasProyecto') {
                    return datos['datos'];
                  }

                  // Antecedentes IGA
                  if (datos['nombre'].includes('Antecedentes IGA') && nodo === 'antecedentesIGA') {
                    return datos['datos'];
                  }


                  for (const keySubDatos in datos['datos']) {

                    if (keySubDatos === 'superficies' && nodo === 'superficies') {
                      return datos['datos']['superficies'];
                    }
                    // Superficies otros
                    if (keySubDatos === 'titularidadTerrenoSuperficial' && nodo === 'titularidadTerrenoSuperficial') {
                      return datos['datos']['titularidadTerrenoSuperficial'];
                    }

                    if (keySubDatos === 'vidaUtil' && nodo === 'vidaUtil') {
                      return datos['datos']['vidaUtil'];
                    }

                    /*================================================
                    =            Areas Efectivas            =
                    ================================================*/
                    if (keySubDatos === 'areaEfectivaProyecto' && keySubDatos === nodo) { resultado = datos['datos']['areaEfectivaProyecto']; } //[]

                    /*================================================
                    =            Descripcion del Proyecto            =
                    ================================================*/
                     // 
                     if (nodo === 'descripcionProyecto' && keySubDatos === 'derechosConcesiones' && nodo2 === 'derechosConcesiones') {
                      resultado = datos['datos']['derechosConcesiones'];
                      return resultado;
                    }
                    // 
                    if (nodo === 'descripcionProyecto' && keySubDatos === 'estudioPrevioAprobado' && nodo2 === 'estudioPrevioAprobado') {
                      resultado = datos['datos']['estudioPrevioAprobado'];
                      return resultado;
                    }
                    // 
                    if (nodo === 'descripcionProyecto' && keySubDatos === 'permisosVigentes' && nodo2 === 'permisosVigentes') {
                      resultado = datos['datos']['permisosVigentes'];
                      return resultado;
                    }
                    // 
                    if (nodo === 'descripcionProyecto' && keySubDatos === 'componentes' && nodo2 === 'componentes') {
                      resultado = datos['datos']['componentes'];
                      return resultado;
                    }

                    // Etapas de Proyecto
                    if (nodo === 'descripcionProyecto' && keySubDatos === 'etapasProyecto' && nodo2 === 'etapasProyecto') {
                      resultado = datos['datos']['etapasProyecto'];
                      return resultado;
                    }

                    // 
                    if (nodo === 'descripcionProyecto' && keySubDatos === 'personal' && nodo2 === 'personal') {
                      resultado = datos['datos']['personal'];
                      return resultado;
                    }
                    // 
                    if (nodo === 'descripcionProyecto' && keySubDatos === 'empleo' && nodo2 === 'empleo') {
                      resultado = datos['datos']['empleo'];
                      return resultado;
                    }


                    // 
                    if (nodo === 'descripcionProyecto' && keySubDatos === 'insumos' && nodo2 === 'insumos') {
                      resultado = datos['datos']['insumos'];
                      return resultado;
                    }
                    // 
                    if (nodo === 'descripcionProyecto' && keySubDatos === 'usoAgua' && nodo2 === 'usoAgua') {
                      resultado = datos['datos']['usoAgua'];
                      return resultado;
                    }
                    // 
                    if (nodo === 'descripcionProyecto' && keySubDatos === 'usoAgua' && nodo2 === 'usoAgua') {
                      resultado = datos['datos']['usoAgua'];
                      return resultado;
                    }
                    // 
                    if (nodo === 'descripcionProyecto' && keySubDatos === 'efluentes' && nodo2 === 'efluentes') {
                      resultado = datos['datos']['efluentes'];
                      return resultado;
                    }
                    // 
                    if (nodo === 'descripcionProyecto' && keySubDatos === 'residuosAextraer' && nodo2 === 'residuosAextraer') {
                      resultado = datos['datos']['residuosAextraer'];
                      return resultado;
                    }
                    // 
                    if (nodo === 'descripcionProyecto' && keySubDatos === 'residuos' && nodo2 === 'residuosAgenerar') {
                      resultado = datos['datos']['residuos']['residuosAgenerar'];
                      return resultado;
                    }
                    // 
                    if (nodo === 'descripcionProyecto' && keySubDatos === 'residuos' && nodo2 === 'manejoResiduosPeligrosos') {
                      resultado = datos['datos']['residuos']['manejoResiduosPeligrosos'];
                      return resultado;
                    }
                    // 
                    if (nodo === 'descripcionProyecto' && keySubDatos === 'residuos' && nodo2 === 'tratamientoResiduosPeligrosos') {
                      resultado = datos['datos']['residuos']['tratamientoResiduosPeligrosos'];
                      return resultado;
                    }
                    // Recursos naturales
                    if (nodo === 'descripcionProyecto' && keySubDatos === 'recursosNaturales' && nodo2 === 'recursosNaturales') {
                      resultado = datos['datos']['recursosNaturales'];
                      return resultado;
                    }





                    /*================================================
                    =            Linea Base            =
                    ================================================*/
                    if (nodo === 'lineaBase') {
                      if (
                        keySubDatos === 'clima' || keySubDatos === 'estacionesMeteorologicas' ||
                        keySubDatos === 'fuentesAgua' || keySubDatos === 'estacionesMuestreo' ||
                        keySubDatos === 'aspectoPoblacion'
                      ) { resultado = datos['datos']; }
                    }


                    /*================================================
                    =            Participación Ciudadana            =
                    ================================================*/
                    if (keySubDatos === 'registroActividades' && keySubDatos === nodo) { resultado = datos['datos']; } //[]


                    if (
                      (keySubDatos === 'manejoAmbiental' && keySubDatos === nodo) ||
                      (keySubDatos === 'compromisoSocial' && keySubDatos === nodo) ||
                      (keySubDatos === 'programaMonitoreo' && keySubDatos === nodo)
                    ) {  //[]
                      // menu.participacionCiudadana = true; 
                      // let datoManejoAmb = datos['datos']['manejoAmbiental'];
                      let datoManejoAmb = datos['datos'][keySubDatos];
                      for (const keyManejoAmb in datoManejoAmb) {
                        let lectura = datoManejoAmb[keyManejoAmb];
                        for (const keyManejos in lectura) {

                          /*================================================
                          =            Impacto Ambiental            =
                          ================================================*/
                          if (keyManejos === 'medios' && keyManejos === nodo2) { resultado = datos['datos']['manejoAmbiental']; } //[]

                          /*================================================
                          =            Manejo Ambiental            =
                          ================================================*/
                          if (
                            (keyManejos === 'manejosAmbientales' && keyManejos === nodo2) ||
                            (keyManejos === 'compromisosSociales' && keyManejos === nodo2) ||                            
                            (keyManejos === 'identificacionPunto' && keyManejos === nodo2)
                          ) {
                            resultado = datos['datos'][keySubDatos];
                          } //[]

                        }
                      }
                    }
                    
                    if (keySubDatos === 'beneficiarios' && keySubDatos === nodo) { resultado = datos['datos']; }

                    /*================================================
                    =            Valoración Económica            =
                    ================================================*/
                    if (keySubDatos === 'valoracionEconomica' && keySubDatos === nodo) {  //[]
                      resultado = datos['datos'];
                    }

                    /*================================================
                    =            Profesionales de consultora          =
                    ================================================*/
                    if (keySubDatos === 'consultora' && keySubDatos === nodo) {  //[]
                      resultado = datos['datos']['consultora'];
                    }

                    if (keySubDatos === 'profesionales' && keySubDatos === nodo) {  //[]
                      resultado = datos['datos']['profesionales'];
                    }

                    /*================================================
                    =            Ubicacion Geografica            =
                    ================================================*/
                    if (keySubDatos === 'ubicacion' && keySubDatos === nodo) {  //[]
                      resultado = datos['datos'];
                    }

                    /*================================================
                    =            Cuencas            =
                    ================================================*/
                    if (keySubDatos === 'cuencas' && keySubDatos === nodo) {  //[]
                      resultado = datos['datos'];
                    }

                    // Datos Generales - Concesiones Mineras 
                    if (keySubDatos === 'derechosConcesiones' && keySubDatos === nodo) {
                      resultado = datos['datos'];
                    }


                    // Situacion Actual del Proyecto
                    if (keySubDatos === 'situacionActualProyecto' && keySubDatos === nodo) {
                      resultado = datos['datos'];
                    }


                    // Objetivos ITS
                    if (keySubDatos === 'objetivosITS' && keySubDatos === nodo) {
                      resultado = datos['datos'];
                    }

                    if (keySubDatos === 'objetivosITS' && keySubDatos === nodo) {
                      resultado = datos['datos'];
                    }

                  }
                }
              }
            }
          }
        }
      }
    }
    return resultado;
  }

  getProfesionales(data: any) {
    let resultado : any;
    resultado = this.getNodo(data, 'consultora');

    if (!resultado) resultado = this.getNodo(data, 'profesionales');

    return resultado;
  }

  getAreaEfectiva(data: any) {
    let resultado = this.getNodo(data, 'areaEfectivaProyecto');
    return resultado;
  }
  // getDescripcionProyecto(data: any) {
  //   let resultado = this.getNodo(data, 'descripcionProyecto');
  //   return resultado;
  // }
  getLineaBase(data: any) {
    let resultado = this.getNodo(data, 'lineaBase');
    return resultado;
  }
  getParticipacionCiudadana(data: any) {
    let resultado = this.getNodo(data, 'registroActividades');
    return resultado;
  }
  getImpactoAmbiental(data: any) {
    let resultado = this.getNodo(data, 'manejoAmbiental', 'medios');
    return resultado;
  }
  getManejoAmbiental(data: any) {
    let resultado = this.getNodo(data, 'manejoAmbiental', 'manejosAmbientales');
    return resultado;
  }

  getBeneficiarios(data: any) {
    let resultado = this.getNodo(data, 'beneficiarios');
    return resultado;
  }

  getCompromisoSocial(data: any) {
    let resultado = this.getNodo(data, 'compromisoSocial', 'compromisosSociales');
    return resultado;
  }
  getProgramaMonitoreo(data: any) {
    let resultado = this.getNodo(data, 'programaMonitoreo', 'identificacionPunto');
    return resultado;
  }
  getValoracionEconomica(data: any) {
    let resultado = this.getNodo(data, 'valoracionEconomica');
    return resultado;
  }
  getUbicacion(data: any) {
    let resultado = this.getNodo(data, 'ubicacion');
    return resultado;
  }
  getCuenca(data: any) {
    let resultado = this.getNodo(data, 'cuencas');
    return resultado;
  }
  getConcesionesMineras(data: any) {
    let resultado = this.getNodo(data, 'derechosConcesiones');
    return resultado;
  }
  getDatosGeneralesCertificacion(data: any) {
    let resultado = this.getNodo(data, 'situacionActualProyecto');
    return resultado;
  }
  getObjetivoITS(data: any) {
    const resultado = this.getNodo(data, 'objetivosITS');
    return resultado;
  }




  
  getComponenteDerechoConsecion(data: any) {
    const resultado = this.getNodo(data, 'descripcionProyecto', 'derechosConcesiones');
    return resultado;
  }
  // estudioPrevioAprobado
  getEstudioPrevioAprobado(data: any) {
    const resultado = this.getNodo(data, 'descripcionProyecto', 'estudioPrevioAprobado');
    return resultado;
  }
  // permisosVigentes
  getPermisosVigentes(data: any) {
    const resultado = this.getNodo(data, 'descripcionProyecto', 'permisosVigentes');
    return resultado;
  }
  // componentes
  getComponentes(data: any) {
    const resultado = this.getNodo(data, 'descripcionProyecto', 'componentes');
    return resultado;
  }
  // personal
  getPersonal(data: any) {
    const resultado = this.getNodo(data, 'descripcionProyecto', 'personal');
    return resultado;
  }
  // empleo
  getEmpleos(data: any) {
    const resultado = this.getNodo(data, 'descripcionProyecto', 'empleo');
    return resultado;
  }
  // insumos
  getInsumos(data: any) {
    const resultado = this.getNodo(data, 'descripcionProyecto', 'insumos');
    return resultado;
  }
  // usoAgua
  getusoAgua(data: any) {
    const resultado = this.getNodo(data, 'descripcionProyecto', 'usoAgua');
    return resultado;
  }
  // residuosAextraer
  getEfluentes(data: any) {
    const resultado = this.getNodo(data, 'descripcionProyecto', 'efluentes');
    return resultado;
  }
  // residuosAextraer
  getManejoResiduosAextraer(data: any) {
    const resultado = this.getNodo(data, 'descripcionProyecto', 'residuosAextraer');
    return resultado;
  }
  // residuosAgenerar
  getManejoResiduosAgenerar(data: any) {
    const resultado = this.getNodo(data, 'descripcionProyecto', 'residuosAgenerar');
    return resultado;
  }
  // manejoResiduosPeligrosos
  getManejoResiduosPeligrosos(data: any) {
    const resultado = this.getNodo(data, 'descripcionProyecto', 'manejoResiduosPeligrosos');
    return resultado;
  }
  // tratamientoResiduosPeligrosos
  getTratamientoResiduosPeligrosos(data: any) {
    const resultado = this.getNodo(data, 'descripcionProyecto', 'tratamientoResiduosPeligrosos');
    return resultado;
  }
  // Recursos naturales
  getRecursosNaturales(data: any) {
    const resultado = this.getNodo(data, 'descripcionProyecto', 'recursosNaturales', 'recursosNaturales');
    return resultado;
  }
  // Etapas del Proyecto
  getEtapasProyecto(data: any) {
    const resultado = this.getNodo(data, 'etapasProyecto');
    return resultado;
  }

  // Superficies
  getSuperficies(data: any) {
    const resultado = this.getNodo(data, 'superficies');
    return resultado;
  }
  getSuperficiesOtros(data: any) {
    const resultado = this.getNodo(data, 'titularidadTerrenoSuperficial');
    return resultado;
  }

  // Vida util del proyecto
  getVidaUtil(data: any) {
    const resultado = this.getNodo(data, 'vidaUtil');
    return resultado;
  }

  getAtecedentesIGA(data: any) {
    const resultado = this.getNodo(data, 'antecedentesIGA');
    return resultado;
  }

  // Etapas de proyecto
  getEtapasDeProyecto(data: any) {
    const resultado = this.getNodo(data, 'descripcionProyecto', 'etapasProyecto');
    return resultado;
  }


  /*=====  End of DATOS  A MOSTRAR EN LAS SECCIONES  ======*/





}
